export const VEHICLE_REG_NUMBER_REGEX: RegExp = /(^[A-Z]{2}\d{2}\s?[A-Z]{3}$)|(^[A-Z]\d{1,3}[A-Z]{3}$)/;
